import React, { Component, Fragment } from 'react';
import Favourite from '../components/Favourite/Favourite';
import FooterDesktop from '../components/common/FooterDesktop';
import FooterMobile from '../components/common/FooterMobile';
import NavMenuDesktop from '../components/common/NavMenuDesktop';
import NavMenuMobile from '../components/common/NavMenuMobile';
import SliderLoading from '../components/PlaceHolder/SliderLoading';
import AppURL from '../api/AppURL'
import axios from 'axios';

class FavouritePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProductData: [],
            isLoading: true,
            mainDiv: "d-none"
        };
    }

    componentDidMount() {
        window.scroll(0, 0);

        // লোকাল স্টোরেজ থেকে email ফেচ করা
        const email = this.props.user?.email || localStorage.getItem('email');

        if (email) {
            axios.get(AppURL.FavouriteList(email))
                .then(response => {
                    this.setState({
                        ProductData: response.data,
                        isLoading: "d-none",
                        mainDiv: " "
                    });
                })
                .catch(error => {
                    console.error("API Call Error:", error);
                });
        } else {
            console.error("User email is not available");
        }
    }


    render() {
        const User = this.props.user;

        if (this.state.mainDiv === "d-none") {
            return (
                <Fragment>
                    <div className="Desktop">
                        <NavMenuDesktop />
                    </div>

                    <div className="Mobile">
                        <NavMenuMobile />
                    </div>

                    <SliderLoading isLoading={this.state.isLoading} />

                    <div className="Desktop">
                        <FooterDesktop />
                    </div>

                    <div className="Mobile">
                        <FooterMobile />
                    </div>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <div className="Desktop">
                        <NavMenuDesktop />
                    </div>

                    <div className="Mobile">
                        <NavMenuMobile />
                    </div>

                    <Favourite data={this.state.ProductData} user={User} />

                    <div className="Desktop">
                        <FooterDesktop />
                    </div>

                    <div className="Mobile">
                        <FooterMobile />
                    </div>
                </Fragment>
            );
        }
    }
}

export default FavouritePage;
